import React, { useCallback, useContext } from 'react';
import { Space, message } from 'antd';
import * as Icons from '@ant-design/icons';
import { HeadPortal } from '@modules/layout/components/head-portal';
import { StyledHeaderButton } from '@modules/layout/styled';
import { StyledActionBar } from '@shared/styled/action-bar';
import { useBackgroundNavigate, useMassiveExport } from '@shared/hooks';
import { downloadXlsx } from '@shared/utils';
import { tableFilterQueryMaker } from '@shared/modules/next-table/utils';
import { useAuth } from '@modules/me';
import { CashFlowTransactionsTableContext } from '../context';
import { CashFlowTransactionsService } from '../services';

export const CashFlowTransactionsActionBar = () => {
  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(CashFlowTransactionsTableContext);
  const { can } = useAuth();
  const navigate = useBackgroundNavigate();
  const selectionCount = Object.keys(state.selectedRowIds || {}).length;

  const { handleExport, exportedData } = useMassiveExport(CashFlowTransactionsService.getListForExport, { resetKey: state.filters });

  const openCreate = useCallback(() => {
    navigate('/cash-flow/transactions/create', { withBackground: true });
  }, [navigate]);

  const handleMassiveExport = useCallback(() => {
    handleExport(tableFilterQueryMaker(state.filters));
  }, [handleExport, state.filters]);

  const exportAsExcel = useCallback(async () => {
    message.loading({ key: 'cashflow-export', content: 'Sənəd hazırlanır...', duration: 0 });
    const result = await CashFlowTransactionsService.getExcel(tableFilterQueryMaker(state.filters));
    if (result.status === 200) {
      message.success({ key: 'cashflow-export', content: 'Sənəd yüklənir' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(result.data as Blob);
      a.download = `cash_flow_transactions_export_${new Date().toISOString()}.xls`;
      a.click();
    } else {
      message.error({ key: 'cashflow-export', content: result.data as string });
    }
  }, [state.filters]);

  return (
    <HeadPortal>
      <StyledActionBar $flex={true}>
        <Space size={0}>
          <StyledHeaderButton type="text" disabled={!can('cashbox_operations.cud')} onClick={openCreate} icon={<Icons.PlusCircleOutlined />}>
            Yeni
          </StyledHeaderButton>
          {!selectionCount ? (
            <StyledHeaderButton type="text" onClick={handleSelectAll} icon={<Icons.CheckCircleOutlined />}>
              Hamısını seç
            </StyledHeaderButton>
          ) : (
            <StyledHeaderButton type="text" onClick={handleResetSelection} icon={<Icons.CloseCircleOutlined />}>
              {selectionCount} sətir seçilib
            </StyledHeaderButton>
          )}
          <StyledHeaderButton type="text" onClick={handleFetch} icon={<Icons.ReloadOutlined />}>
            Yenilə
          </StyledHeaderButton>
          <StyledHeaderButton type="text" onClick={handleReset} icon={<Icons.ClearOutlined />}>
            Sıfırla
          </StyledHeaderButton>
          {exportedData.length ? (
            <StyledHeaderButton type="text" onClick={() => downloadXlsx(exportedData, `cashflow_transactions_list_${Math.round(Math.random() * 1000)}`)} icon={<Icons.FileExcelOutlined />}>
              Yüklə
            </StyledHeaderButton>
          ) : (
            <StyledHeaderButton type="text" onClick={handleMassiveExport} icon={<Icons.FileExcelOutlined />}>
              Export
            </StyledHeaderButton>
          )}
        </Space>
        <Space size={0}>
          <StyledHeaderButton type="text" onClick={exportAsExcel} icon={<Icons.FileExcelOutlined />}>
            Excel
          </StyledHeaderButton>
        </Space>
      </StyledActionBar>
    </HeadPortal>
  );
};
